export default "__VITE_ASSET__2b89acb8__"